import styled from 'styled-components';
import THEME from 'theme';
import { Container, Column } from '@iag-packages/chroma-react/lib/layouts';
import { SCREEN } from 'scenes/common/types/screen';
import { FullPageRowProps } from './types';

type FullPageRootProp = {
  shouldSkipHardcodedHeadingColor?: boolean;
};
export const FullPageRoot = styled.div<FullPageRootProp>`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .c-label {
    color: ${(props) =>
      !props.shouldSkipHardcodedHeadingColor &&
      `${THEME.TEXT.HEADING}!important`};
  }

  p {
    color: ${THEME.TEXT.BODY};
  }
`;

export const FullPageContainer = styled(Container)`
  margin-left: 0px;
  margin-right: 0px;
  min-width: 100vw;
  min-height: 100vh;
`;

export const StyledContainer = styled(Container)`
  padding-bottom: 2rem;
`;

export const FullPageRow = styled.div<FullPageRowProps>`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: no-wrap;
  margin-right: -16px;
  margin-left: -16px;
  min-height: 100vh;

  .col-9:first-of-type {
    flex: auto !important;

    @media (min-width: ${SCREEN.EXTRA_LARGE}px) {
      max-width: ${(props) => (props.displaySidebar ? 'none' : '')};
    }

    @media (min-width: ${SCREEN.LARGE}px) {
      padding: ${(props) => (props.motorExperimentalStyles ? '0' : '')};
    }
  }

  .col-12:first-of-type {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const MobilePaddingContainer = styled.div`
  @media (max-width: ${SCREEN.LARGE}px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const FooterContainer = styled.footer`
  @media (max-width: ${SCREEN.LARGE}px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  @media (max-width: ${SCREEN.MEDIUM}px) {
    margin-top: 40px;
  }
  @media (max-width: ${SCREEN.SMALL}px) {
    margin-top: 0px;
  }
`;

export const UpperContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;

  @media (min-width: ${SCREEN.MEDIUM}px) {
    min-height: 100vh;
  }
`;

export const SidebarColumn = styled(Column)`
  border-left: 1px solid ${THEME.SIDEBAR.BORDER};
  padding: 0 1em;
  min-width: 440px;
  max-width: 440px;
`;
